import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

// Phase 4b-0 + 4b-1 management page. Reachable at /governance-apps; renders the
// human's owned apps + their client roles via the governance-admin BFF, and (4b-1)
// creates, edits, deletes and assigns those roles through the same BFF.
const controlPlaneAdminPage = PageBlueprint.make({
  name: 'governance-apps',
  params: {
    path: '/governance-apps',
    loader: async () => {
      const { ControlPlaneAdminPage } = await import('./ControlPlaneAdminPage');
      return <ControlPlaneAdminPage />;
    },
  },
});

export const controlPlaneAdminModule = createFrontendModule({
  pluginId: 'app',
  extensions: [controlPlaneAdminPage],
});
